import type { KeyboardEvent } from 'react'

export const keyPress = (event: KeyboardEvent<HTMLAnchorElement>) => {
  // Make buttons keyboard accessible again
  const isSpaceOrEnterKey = [' ', 'Enter'].includes(event.key)
  const element = event.target as HTMLElement

  isSpaceOrEnterKey && element.click()
}
